import styled from 'styled-components';

const CardWrapper = styled.div`
    margin-top: 8px;
`;

export default CardWrapper;
